import * as STD                                         from '@emersya/mpa-std-lib';
import CM                                               from '@emersya/mpa-components-manager-lib';

export type TValue = Set<CM.DOMComponent<any, any, any>>;

export interface IInputSelectMultipleComponentConfiguration extends IInputComponentConfiguration<
	TValue,
	CM.Component.TId[]
>
{
};

export class InputSelectMultipleComponent extends InputComponent<
	HTMLDivElement,
	TValue,
	CM.Component.TId[],
	InputSelectMultipleComponent,
	IInputSelectMultipleComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	override async component_initialize() {
		await super.component_initialize();
		this.addEventListener('value', this.onInputButton.bind(this), {
			subType :  'input-button',
			listener : this
		});
		this.addEventListener('value', this.onValueUpdated.bind(this), {
			subType :  'input-select-multiple',
			listener : this
		});
	};

	async reset() {
		const _dv = this.component_configuration.defaultValue;
		const dv = this.deserialize(_dv || []);
		await this.updateValue(dv);
	};

	private async onInputButton(ev : STD.events.Event<any, CM.Component<any, any>>) {
		const selected = ev.target as CM.DOMComponent<any, any, any>;
		await this.toggle(selected);
	};

	private onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		const diff = STD.object.setCompareVersion<CM.DOMComponent<any, any, any>>(
			ev.details.newValue,
			ev.details.oldValue || new Set
		);
		for (const removed of diff.removed) {
			removed.component_DOM.classList.remove('selected');
		}
		for (const added of diff.added) {
			added.component_DOM.classList.add('selected');
		}
	};

	override deserialize(
		x : TValue | CM.Component.TId[]
	)
	{
		if (!x) {
			return (<TValue> new Set);
		}
		if (x instanceof Set) {
			return (x);
		}
		return (new Set(<CM.DOMComponent<any, any, any>[]> x.map(
			selectedId => this.component_findOuter([ selectedId ])
		)));
	};

	async updateValueFromId(id : string) {
		const child = this.component_findOuter([ id ]);
		if (!child) {
			throw STD.errors.user(`Child<${ id }> not found!`, {
				component : this,
				id
			});
		}
		await this.toggle(<CM.DOMComponent<any, any, any>> child);
	};

	async toggle(child : CM.DOMComponent<any, any, any>) {
		const value = new Set(this.value || []);
		if (value.has(child)) {
			value.delete(child);
		} else {
			value.add(child);
		}
		await this.updateValue(value);
	};

	override isValueTheDefault() {
		return (
			(this.value === this.defaultValue) ? true :
				(
					(this.value && !this.defaultValue) ||
					(!this.value && this.defaultValue)
				) ? false :
					STD.object.hasSameContent(
						Array.from((<NonNullable<typeof this.value>> this.value).values()).map(x => x.component_getPath()).sort(),
						Array.from((<NonNullable<typeof this.defaultValue>> this.defaultValue).values()).
						map(x => x.component_getPath()).
						sort(),
					)
		);
	};

	serialize() {
		return !this.value ? null : Array.from(this.value).map(x => x.id);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IInputSelectMultipleComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.value = new Set;
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
	};
};
export namespace NS {
	export const Component = InputSelectMultipleComponent;
	export type Component = InputSelectMultipleComponent;
	export type Configuration = IInputSelectMultipleComponentConfiguration;
}
;
import { InputComponent, IInputComponentConfiguration } from '../Input/Input';
import './InputSelectMultiple.scss';

CM.declare({
	id :   'input-select-multiple',
	type : InputSelectMultipleComponent
});
